import { render, staticRenderFns } from "./ActionsDashboard.vue?vue&type=template&id=687e0ec5&"
import script from "./ActionsDashboard.vue?vue&type=script&lang=js&"
export * from "./ActionsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports